export default __webpack_public_path__ + "static/media/fr1000.c28cebbf.webp";